export default {"src":"/_next/static/media/pet-sitter.fe2019d0.svg","height":79,"width":78,"blurWidth":0,"blurHeight":0};